import PartyName, { PartyNameVariant } from 'components/party/PartyName';
import { EmployeeNameLink } from 'components/record-chip/RecordLink';
import { Fragment } from 'react';
import { NamedEntityMinDto } from 'types/other';
import { PartyNameParty } from 'utils/partyNameUtil';

type EntityLinkListProps = {
    domain: string;
    prefix?: string;
    items: NamedEntityMinDto[] | undefined;
    useOriginLink?: boolean;
    displayEmptyList?: boolean;
    partyVariant?: PartyNameVariant;
    /** Opens employee (non-contact) links in a new browser tab. */
    newTab?: boolean;
};

export default function EntityLinkList({
    domain,
    prefix,
    items,
    useOriginLink = true,
    displayEmptyList = false,
    partyVariant = 'readonly-other',
    newTab = false,
}: EntityLinkListProps) {
    const processedItems = items?.filter(Boolean) || [];
    if (processedItems.length === 0 && !displayEmptyList) {
        return;
    }
    const isContact = domain === 'contact';
    return (
        <span>
            {prefix ? <span className="text-body1 text-fg-secondary mr-[.5ch]">{prefix}:</span> : null}
            {processedItems.map((item, index) => {
                const optionalComma = index < processedItems.length - 1 ? `, ` : null;
                return (
                    <Fragment key={item.id}>
                        {isContact ? (
                            <PartyName
                                party={item as PartyNameParty}
                                isLink
                                useLinkWithOrigin={useOriginLink}
                                variant={partyVariant}
                            />
                        ) : (
                            <EmployeeNameLink
                                to={`/${domain}/${item.id}`}
                                entity={item}
                                withOrigin={useOriginLink}
                                target={newTab ? '_blank' : undefined}
                                rel={newTab ? 'noopener noreferrer' : undefined}
                                // `entity-link` is a targeting hook for the table-cell and detail-row link rules.
                                className="entity-link text-fg hover:text-link no-underline hover:underline"
                            />
                        )}
                        {optionalComma}
                    </Fragment>
                );
            })}
        </span>
    );
}
